import { useFlags } from "launchdarkly-react-client-sdk";
import { Icon } from "src/components/layout/nav/icons/ad-studio";
import { UseSectionHook } from "./types";
import { NavSection } from "src/components/layout/nav/nav-section";
import { ActiveSectionProps } from "src/components/layout/nav/utils";
import { useDevSettings } from "src/pages/agents/hooks/use-dev-settings";
import { useIsAdStudioEnabled } from "src/pages/agents/hooks/use-is-ad-studio-enabled";
import { useResourcePermission } from "src/components/permission/use-resource-permission";

export const useAdStudioSection: UseSectionHook = () => {
  const { settings } = useDevSettings();
  const isAdStudioEnabled = useIsAdStudioEnabled();
  const { adStudioStyles, adStudioEnrichedCatalogs, adStudioTemplates } =
    useFlags();

  return {
    title: "Ad Studio",
    isEnabled: isAdStudioEnabled,
    links: [
      {
        isSub: true,
        href: "/ad-studio/projects",
        label: "Ads",
        activePaths: [
          "/ad-studio/ads",
          "/ad-studio/favorites",
          "/ad-studio/created-by-you",
          "/ad-studio/ideas",
          "/ad-studio/launch",
          "/ad-studio/folders",
        ],
      },
      ...(adStudioTemplates
        ? [
            {
              isSub: true as const,
              href: "/ad-studio/templates",
              label: "Templates",
            },
          ]
        : []),
      ...(adStudioStyles
        ? [
            {
              isSub: true as const,
              href: "/ad-studio/styles",
              label: "Styles",
            },
          ]
        : []),
      ...(adStudioEnrichedCatalogs
        ? [
            {
              isSub: true as const,
              href: "/ad-studio/catalog-ads",
              label: "Catalog ads",
            },
          ]
        : []),
      {
        isSub: true,
        href: "/ad-studio/insights",
        label: "Insights",
      },
      {
        isSub: true,
        href: "/ad-studio/assets",
        label: "Assets",
      },
      ...(settings.isDevMode
        ? [
            {
              isSub: true,
              href: "/ad-studio/artifacts",
              label: "Artifacts",
            },
          ]
        : []),
    ],
  };
};

export const AdStudio = (props: ActiveSectionProps) => {
  const section = useAdStudioSection();
  const { isPermitted: canViewAgents } = useResourcePermission({
    v2: { resource: "workspace", grant: "can_view_agents" },
  });

  if (!canViewAgents) {
    return null;
  }

  return <NavSection icon={Icon} {...section} {...props} />;
};
